import { graphql } from '../graphql';
import { useRequest } from '../hooks/useRequest';
const UPLOAD_FILE = graphql(`
  mutation UploadFile(
    $id: String!
    $fileName: String!
    $fileContent: String!
    $timestamp: String!
    $caption: String
  ) {
    uploadFile(
      input: {
        id: $id
        fileName: $fileName
        fileContent: $fileContent
        timestamp: $timestamp
        caption: $caption
      }
    )
  }
`);
export const useUploadFileRequest = () => {
    return useRequest(UPLOAD_FILE, {});
};
